import { render, staticRenderFns } from "./DeductLevel.vue?vue&type=template&id=157133c3&"
import script from "./DeductLevel.vue?vue&type=script&lang=js&"
export * from "./DeductLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports